<template>
  <div>
    <div class="bg-white py-3 py-sm-0">
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col>
          <b-table
            id="table-finance"
            responsive
            class="text-center table-list mb-0"
            striped
            :fields="fields"
            :items="items"
            :busy="isBusy"
            show-empty
            empty-text="ไม่พบข้อมูล"
          >
            <template v-slot:cell(createdTime)="data">
              <span>{{
                new Date(data.item.createdTime) | moment($formatDateTime)
              }}</span>
            </template>

            <template v-slot:cell(netIncome)="data">
              <p class="m-0">฿ {{ data.item.netIncome | numeral("0,0.00") }}</p>
            </template>

            <template v-slot:cell(amountReceive)="data">
              <p class="m-0">
                ฿ {{ data.item.amountReceive | numeral("0,0.00") }}
              </p>
            </template>

            <template v-slot:cell(paymentStatus)="data">
              <b-badge
                v-if="data.item.paymentStatus === 'รอการยืนยันธุรกรรม'"
                pill
                variant="primary"
                class="px-3 py-2 mt-1 badge-primary"
                >{{data.item.paymentStatus}}</b-badge
              >
              <b-badge v-else pill variant="success" class="px-3 py-2 mt-1"
                >{{data.item.paymentStatus}}</b-badge
              >
            </template>

            <template v-slot:cell(detail)="data">
              <b-button variant="link" class="px-1 py-0">
                  <router-link
                    :to="
                      '/finance/details/' +
                      data.item.id +
                      '?brandID=' +
                      $route.query.brandID
                    "
                    class="text-purple-1"
                  >
                    <u>ดูรายละเอียด</u>
                  </router-link> </b-button
                ><br />
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="no-gutters px-3 px-sm-0" v-if="!isBusy">
        <b-col
          class="form-inline justify-content-center justify-content-sm-end"
        >
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.page"
              :total-rows="rows"
              :per-page="filter.take"
              class="m-md-0 page-item"
              aria-controls="table-finance"
              align="center"
              @change="pagination"
            ></b-pagination>
          </div>
          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filter.take"
            @change="hanndleChangePerpage"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      required: false,
      type: Array
    },
    rows: {
      required: false,
      type: Number
    },
    isBusy: {
      required: false,
      type: Boolean
    },
    filter: {
      required: false,
      type: Object
    },
    getFinanceList: {
      required: false,
      type: Function
    },
  },
  data() {
    return {
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      fields: [
        {
          key: "statementNo",
          label: `เลขที่รายการ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "createdTime",
          label: `วันที่รายการ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "salesChannel",
          label: `ช่องทางสั่งซื้อ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "statementPayment",
          label: `ช่องทางการชำระเงิน`,
          class: "w-100px text-nowrap",
        },
        {
          key: "netIncome",
          label: `รายได้`,
          class: "w-100px text-nowrap",
        },
        {
          key: "amountReceive",
          label: `จำนวนเงินที่ได้รับ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "orderCount",
          label: `จำนวนออเดอร์`,
          class: "w-100px text-nowrap",
        },
        {
          key: "paymentStatus",
          label: `สถานะการชำระเงิน`,
          class: "w-100px text-nowrap",
        },
        {
          key: "detail",
          label: ``,
          class: "w-100px text-nowrap",
        },
      ],
    };
  },
  methods: {
    hanndleChangePerpage(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.getFinanceList();
      this.onsetFilter();
    },
    pagination(page) {
      this.filter.page = page;
      this.getFinanceList();
      this.onsetFilter();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep a {
  text-decoration: underline;
}
.badge-primary {
  background-color: #e3e2f2;
  color: #8078c6;
}
</style>
